import Axios from "axios";
import labels from "./labels.json";
import _ from "lodash";
import CryptoJS from "crypto-js";

// import { states } from "./constants";
export const getErrorMessage = (error) =>
  error.message
    ? error.message
    : error.error && typeof error.error === "string"
    ? error.error
    : typeof error === "string"
    ? error
    : "Something went wrong!";

export const uploadToAws = async (url, file) => {
  return await new Promise(async (resolve, reject) => {
    try {
      const __ = await Axios.put(url, file);
      if (__) {
        resolve(url);
      } else {
        reject();
      }
    } catch (error) {
      reject(error);
    }
  });
};

export function getPartyLabelByStatus(status) {
  switch (status) {
    case "draft":
      return "Draft";
    case "underReview":
      return "Under Verification";
    case "active":
      return "Active";
    default:
      return _.startCase(status);
  }
}

export function getFileName(uri) {
  if (uri?.length) {
    const names = uri?.split("/");
    if (names.length) {
      return names[names.length - 1];
    }
  }
}

export function getLabelByPartyStatus(status) {
  switch (status) {
    case "underReview":
      return labels.profile_filters.under_verification;
    case "draft":
      return labels.profile_filters.drafts;
    default:
      return labels.profile_filters.active;
  }
}

export function getCaseLabelByStatus({
  status,
  uploadedDocuments,
  subscriptionKind,
}) {
  switch (status) {
    case "draft":
      return "Draft";
    case "pendingRegistrationFee":
      return "Awaiting Payment";
    case "negotiationReached":
      return subscriptionKind === "adhoc" ? "Settled" : "Awaiting Payment";
    case "negotiationOngoing":
      return "Under Resolution";
    case "claimantPaidNegotiationSuccessFee":
      return uploadedDocuments && uploadedDocuments.length > 0
        ? "Settled"
        : "Awaiting Agreement";
    case "respondentPaidNegotiationSuccessFee":
      return uploadedDocuments && uploadedDocuments.length > 0
        ? "Settled"
        : "Awaiting Payment";
    case "awaitingRespondentAcceptance":
      return "Waiting For Respondent";
    case "bothPaidNegotiationSuccessFee":
      return uploadedDocuments && uploadedDocuments.length > 0
        ? "Settled"
        : "Awaiting Agreement";
    case "waitingForCaseApproval":
      return "Waiting For Case Approval";
    case "waitingForArbitratorConfirmation":
      return "Waiting for Arbitrator Confimation";

    // new life cycle stages

    case "noticeToArbitrate":
      return "Notice to Arbitrate";
    case "arbitrationReferenced":
      return "Arbitration Referenced";
    case "arbitrationNominated":
      return "Arbitrator Nominated";
    case "arbitrationConfirmed":
      return "Arbitrator Confirmation";
    case "firstNoticeSent":
      return "First Notice Sent";
    case "statementOfClaimFiled":
      return "Statement of Claim Filed";
    case "awaitingForSec17Details":
      return "Awaiting for Sec 17 details";
    case "sec17PetitionFiled":
      return "Sec 17 Petition Filed";
    case "sec17Ordered":
      return "Sec 17 Ordered";
    case "awaitingSec17Execution":
      return "Awaiting Sec 17 Execution";
    case "sec17ExtensionMemoFiled":
      return "Sec 17 Extension Memo Filed";
    case "sec17ExtensionMemoOrdered":
      return "Sec 17 Extension Memo Ordered";
    case "fsOrdered":
      return "FS Ordered";
    case "attachmentOrdered":
      return "Attachment Ordered";
    case "garnisheeProhibitaryOrder":
      return "Garnishee Prohibitary Order";
    case "garnisheeFinalOrder":
      return "Garnishee Final Order";
    case "sec17Closed":
      return "Sec 17 Closed";
    case "statementOfDefenceFiled":
      return "Statement of Defence Filed";
    case "rejoinderFromClaimant":
      return "Rejoinder from Claimant";
    case "surrejoinderFromRespondent":
      return "Surrejoinder From Respondent";
    case "2ndNoticeMOM":
      return "2nd Notice MOM";
    case "evidenceFiledByClaimant":
      return "Evidence Filed by Claimant";
    case "evidenceFiledByRespondent":
      return "Evidence Filed by Respondent";
    case "crossExamination":
      return "Cross Examination";
    case "argumentsByClaimant":
      return "Arguments by Claimant";
    case "argumentsByRespondent":
      return "Arguments by Respondent";
    case "reservedForAward":
      return "Reserved for Award";
    case "awardPassed":
      return "Award Passed";
    case "quitByClaimant":
      return "Quit by Claimant";
    case "quitByRespondent":
      return "Quit by Respondent";
    case "resolutionFailed":
      return "Resolution Failed";
    case "closedByCaseManager":
      return "Closed By CaseManager";
    case "settledAndWithdrawn":
      return "Settled & Withdrawn";
    case "updatedAndWithdrawn":
      return "Updated & Withdrawn";
    default:
      return _.startCase(status);
  }
}

export function formatNumberToMetrics(value = "", unit = "") {
  if (!value || unit !== "INR") return value;

  var afterPoint = "";
  if (value.indexOf(".") > 0)
    afterPoint = value?.substring(value?.indexOf("."), value?.length);
  value = Math.floor(value);
  value = value?.toString();
  var lastThree = value?.substring(value.length - 3);
  var otherNumbers = value?.substring(0, value.length - 3);
  if (otherNumbers !== "") lastThree = "," + lastThree;
  var res =
    otherNumbers?.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
    lastThree +
    afterPoint;
  return res;
}

export const renderFeeKind = (value, { resolutionKind }) => {
  if (resolutionKind === "mediation") {
    if (_.snakeCase(value) === "case_registration") {
      return value?.replace("Case", "Mediation");
    }
    return value?.replace("Negotiation", "Mediation");
  } else if (resolutionKind === "negotiation") {
    if (_.snakeCase(value) === "case_registration") {
      return value?.replace("Case", "Negotiation");
    }
    return value?.replace("Negotiation", "Negotiation");
  } else {
    if (_.snakeCase(value) === "case_registration") {
      return value?.replace("Case", "Arbitration");
    }
    return value?.replace("Negotiation", "Arbitration");
  }
};

export const downloadWithDifferenFileName = (url, name) => {
  if (!name) name = url.split("\\").pop().split("/").pop();
  fetch(url, {
    headers: new Headers({
      Origin: window.location.origin,
    }),
    mode: "cors",
  })
    .then((response) => response.blob())
    .then((blob) => {
      let blobUrl = window.URL.createObjectURL(blob);
      forceDownload(blobUrl, name);
    })
    .catch((e) => console.error(e));
};

function forceDownload(blob, filename) {
  var a = document.createElement("a");
  a.download = filename;
  a.href = blob;
  a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/**
 * @description Function to parse time stamp
 * @param {*} data
 */
export const parseTimeStamp = (data) => {
  return data + "Z";
};

export const numberFormat = (value, currency) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: currency ? currency : "INR",
  }).format(value);

export function getFileNameDoc(uri) {
  if (uri?.length) {
    if (uri?.length > 1) {
      const names = uri?.map((item) => item?.split("/"));
      if (names.length) {
        return "Multiple";
      }
    } else {
      const names = uri?.map((item) => item?.split("/"));
      if (names.length) {
        return names.map((data) => data[data.length - 1]);
      }
    }
  }
}

export function randomAlphaNumeric() {
  let s = "";
  let length = 6;
  Array.from({ length }).some(() => {
    s += Math.random().toString(36).slice(2);
    return s.length >= length;
  });
  return s.slice(0, length);
}

export function convertTo12HourFormat(timeString) {
  // Parse the input time string
  const [hours, minutes] = timeString.split(":").map(Number);

  // Determine AM or PM
  const period = hours >= 12 ? "PM" : "AM";

  // Convert hours to 12-hour format
  const formattedHours = hours % 12 || 12;

  // Create the formatted time string
  const formattedTime = `${formattedHours}:${minutes} ${period}`;

  return formattedTime;
}

export function encrypt(
  num,
  REFUND_SECRET_KEY = "lPQP1TMJZ4iWsYhKAOQWi2jlT8p6J7cB"
) {
  const encrypted = CryptoJS.AES.encrypt(
    num.toString(),
    REFUND_SECRET_KEY
  ).toString();
  return encrypted;
}

export const getMimeType = (fileName) => {
  const extension = fileName.split(".").pop();
  switch (extension) {
    case "png":
      return "image/png";
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "pdf":
      return "application/pdf";
    case "docx":
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case "xlsx":
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case "mp3":
      return "audio/mpeg";
    case "txt":
      return "text/plain";
    case "xls":
      return "application/vnd.ms-excel";
    case "tiff":
      return "image/tiff";
    case "tif":
      return "image/tiff";
    default:
      return "application/pdf";
  }
};

export const getFileFormat = (url) => {
  return url.split(".").pop().toLowerCase();
};

export function getPathAfterCaseManager(url) {
  const parts = url.split("/").filter(Boolean); // Split by '/' and remove empty parts
  const caseManagerIndex = parts.indexOf("case-manager");

  if (caseManagerIndex !== -1 && caseManagerIndex + 1 < parts.length) {
    const nextSegment = parts[caseManagerIndex + 1];

    // Check if next segment is NOT a number
    if (!/^\d+$/.test(nextSegment)) {
      return nextSegment;
    }
  }
  return null;
}

export const formatToIST = (iso) => {
  const date = new Date(iso);

  const istDate = new Date(date.getTime() + 5.5 * 60 * 60 * 1000); // UTC → IST

  const dd = String(istDate.getDate()).padStart(2, "0");
  const mm = String(istDate.getMonth() + 1).padStart(2, "0");
  const yyyy = istDate.getFullYear();

  const hh = String(istDate.getHours()).padStart(2, "0");
  const min = String(istDate.getMinutes()).padStart(2, "0");
  const ss = String(istDate.getSeconds()).padStart(2, "0");

  return `${dd}/${mm}/${yyyy} ${hh}:${min}:${ss}`;
};
